import ModelUtil from '@leverege/model-util';
import ExportFieldModel from "./ExportFieldModel.js";
import Attributes from "../../attribute/Attributes.js";
import Formatters from "../../attribute/formatter/Formatters.js";
import Util from "./Util.js";
function getName(data) {
  return Attributes.getDisplayName(data.attrName, data.objectType);
}
const base = {
  ...ExportFieldModel,
  getName,
  ...ModelUtil.createAllValue('formatter'),
  ...ModelUtil.createAllValue('customFormat')
};
delete base.create;
function createFor(unitType) {
  const formatter = Formatters.createFormatterModel(unitType);
  function create({
    attrName,
    objectType,
    ...rest
  }) {
    return ExportFieldModel.create(Util.getExportFieldTypeForType(unitType), {
      attrName,
      objectType,
      formatter,
      ...rest,
      customFormat: true
    });
  }
  return {
    create,
    ...base
  };
}
export default {
  createFor,
  ...base
};